<form class="feedback-container"
      [formGroup]="feedback"
      [class]="themeService.getTheme()"
      [style.margin-top]="showSection('left') ? 0 : 102"
      *ngIf="!isMobile"
>
  <div class="feedback-title" *ngIf="showSection('right')">
    <app-texts
      *ngIf="!isMobile"
      [texts]="[
        {text: ['Get ', 'Get '],},
        {text: ['in Touch', 'in Touch'], fontFamily: 'pd', fontStyle: 'italic'},
      ]"
    />
    <app-texts
      *ngIf="isMobile"
      [texts]="[
        {text: ['Get ', 'Get '],},
        {text: ['in Touch', 'in Touch']},
      ]"
    />
  </div>
  <div class="feedback-workspace">
    <div class="feedback-workspace-left" *ngIf="showSection('left')">
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          <app-texts [texts]="[
            {text: ['Почта', 'Email']}
          ]"/>
        </div>
        <div class="feedback-workspace-el-text">
          <div class="feedback-workspace-el-text-cursor" (click)="openEmail()">
            {{ 'info@ilovefirstclass.com' }}
          </div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          <app-texts [texts]="[
            {text: ['Телефон', 'Phone']}
          ]"/>
        </div>
        <div class="feedback-workspace-el-text">
          <div class="feedback-workspace-el-text-cursor" (click)="openPhoneCall()">+66 99 160 97 11</div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          Telegram
        </div>
        <div class="feedback-workspace-el-text">
          <div class="feedback-workspace-el-text-cursor" (click)="openTelegram()">{{ '@ilovefirstclass' }}</div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          Whatsapp
        </div>
        <div class="feedback-workspace-el-text">
          <div class="feedback-workspace-el-text-cursor" (click)="openWhatsApp()">+66 99 160 97 11</div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          Instagram
        </div>
        <div class="feedback-workspace-el-text">
          <div class="feedback-workspace-el-text-cursor" (click)="openInstagramProfile()">{{ '@ilovefirstclass' }}</div>
        </div>
      </div>
    </div>
    <div class="feedback-workspace-right" *ngIf="showSection('right')">
      <div class="feedback-workspace-right-double-el">
        <div class="feedback-workspace-el">
          <div class="feedback-workspace-el-label">
            <app-texts [texts]="[
              {text: ['Имя', 'Full name']}
            ]"/>
          </div>
          <input
            id="fullName"
            type="text"
            inputmode="text"
            formControlName="fullName"
            [class.error]="isFieldInvalid('fullName')"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
          >
          <div class="field-error" *ngIf="isFieldInvalid('fullName')">
            <app-texts [texts]="[
              {text: ['Пожалуйста, введите ваше полное имя', 'Please enter your full name']}
            ]"/>
          </div>
        </div>
        <div class="feedback-workspace-el">
          <div class="feedback-workspace-el-label">
            <app-texts [texts]="[
              {text: ['Компания', 'Company']}
            ]"/>
          </div>
          <input
            id="company"
            type="text"
            inputmode="text"
            formControlName="company"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
          >
        </div>
      </div>
      <div class="feedback-workspace-right-double-el">
        <div class="feedback-workspace-el">
          <div class="feedback-workspace-el-label">
            <app-texts [texts]="[
              {text: ['Телефон', 'phone number']}
            ]"/>
          </div>
          <input
            id="phoneNumber"
            type="text"
            inputmode="text"
            formControlName="phoneNumber"
            [class.error]="isFieldInvalid('phoneNumber')"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
          >
          <div class="field-error" *ngIf="isFieldInvalid('phoneNumber')">
            <app-texts [texts]="[
              {text: ['Пожалуйста, введите корректный номер телефона', 'Please enter a valid phone number']}
            ]"/>
          </div>
        </div>
        <div class="feedback-workspace-el">
          <div class="feedback-workspace-el-label">
            <app-texts [texts]="[
              {text: ['Почта', 'EMAIL']}
            ]"/>
          </div>
          <input
            id="email"
            type="text"
            inputmode="text"
            formControlName="email"
            [class.error]="isFieldInvalid('email')"
            (focus)="onInputFocus()"
            (blur)="onInputBlur()"
          >
          <div class="field-error" *ngIf="isFieldInvalid('email')">
            <app-texts [texts]="[
              {text: ['Пожалуйста, введите корректный адрес электронной почты', 'Please enter a valid email address']}
            ]"/>
          </div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          <app-texts [texts]="[
              {text: ['Тема запроса', 'Subject of the request']}
            ]"/>
        </div>
        <div class="feedback-dropdown">
          <div
            class="dropdown-display"
            [class.error]="isFieldInvalid('subject')"
            (click)="openList = !openList"
          >
            <ng-container *ngIf="currentSubjectText.text && (currentSubjectText.text[0] || currentSubjectText.text[1]); else noSelection">
              <app-texts [texts]="[currentSubjectText]" />
            </ng-container>
            <ng-template #noSelection>
              <span>
                <app-texts [texts]="[
                  {text: ['Выберите тему', 'Select subject']}
                ]"/>
              </span>
            </ng-template>
          </div>
          <input
            id="subject"
            type="hidden"
            formControlName="subject"
            [value]="value"
            style="display: none"
          >
          <app-icon
            [icon]="Icons.formArrow"
            style="cursor: pointer"
            (click)="openList = !openList"
            [invert]="getInvert()"
            [ngClass]="{ 'dropdown-arrow': true, 'open': openList }"
          />
          <div @slideInOut *ngIf="openList" class="feedback-dropdown-list">
            <div *ngFor="let el of textsEl; index as i">
              <div class="feedback-dropdown-list-el" (click)="selectItem(i)">
                <app-texts [texts]="[el]" />
              </div>
            </div>
          </div>
          <div class="field-error" *ngIf="isFieldInvalid('subject')">
            <app-texts [texts]="[
              {text: ['Пожалуйста, выберите тему', 'Please select a subject']}
            ]"/>
          </div>
        </div>
      </div>
      <div class="feedback-workspace-el">
        <div class="feedback-workspace-el-label">
          <app-texts [texts]="[
              {text: ['Сообщение', 'message']}
            ]"/>
        </div>
        <textarea
          id="message"
          type="text"
          inputmode="text"
          formControlName="message"
          #messageTextarea
          (input)="onInput(messageTextarea)"
          [class.error]="false"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
        ></textarea>
      </div>
      <div class="item-button">
        <div class="button-content">
          <div
            class="button-checkbox"
            [ngClass]="{'warning': isCheckboxWarning}"
            (click)="toggleRead()"
          >
            <div class="button-checkbox-icon" *ngIf="read">
              <app-icon [icon]="Icons.check" [invert]="!getInvert()"/>
            </div>
          </div>
          <div class="button-checkbox-text" [ngClass]="{'warning': isCheckboxWarning}">
            <span class="checkbox-text-line">
              {{ text(['Даю согласие на обработку ', 'I have read the terms of ' ]) }}<span
              class="checkbox-link"
              [ngClass]="{'warning-link': isCheckboxWarning}"
              (click)="openPdf()"
              [innerText]="policyText"></span><span *ngIf="!isMobile">{{ text(['', ' and consent to the processing of personal data']) }}</span>
</span>
          </div>
        </div>
        <div class="submit-button-container">
          <div class="submit-button"
               [class.disabled]="!read || isLoading"
               [style.width]="isMobile ? '100%' : 'auto'"
               [style.justify-content]="isMobile ? 'center' : ''"
               [style.color]="isMobile ? 'white' : 'black'"
               [style.background]="isMobile ? 'black' : 'white'"
               (click)="postFeedback()">
            <span *ngIf="!isLoading">
              <app-texts [texts]="[
                {text: ['Отправить', 'Make request']}
              ]"/>
            </span>
            <span *ngIf="isLoading" class="loading-text">
              <span class="loading-dot">.</span>
              <span class="loading-dot">.</span>
              <span class="loading-dot">.</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div *ngIf="isMobile">
<!--  <div class="sticky-section-wrapper" [ngStyle]="getWrapperStyles()">-->
<!--    <div class="sticky-section" [ngStyle]="getStickyStyles()">-->
      <form class="feedback-container"
            [formGroup]="feedback"
            [class]="themeService.getTheme()"
            [style.margin-top]="showSection('left') ? 0 : 102"
            #blockContainer
      >
        <div class="feedback-title" *ngIf="showSection('right')">
          <app-texts
            *ngIf="!isMobile"
            [texts]="[
        {text: ['Get ', 'Get '],},
        {text: ['in Touch', 'in Touch'], fontFamily: 'pd', fontStyle: 'italic'},
      ]"
          />
          <app-texts
            *ngIf="isMobile"
            [texts]="[
        {text: ['Контакты', 'Get '],},
        {text: [' ', 'in Touch']},
      ]"
          />
        </div>
        <div class="feedback-workspace">
          <div class="feedback-workspace-left" *ngIf="showSection('left')">
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                <app-texts [texts]="[
            {text: ['Почта', 'Email']}
          ]"/>
              </div>
              <div class="feedback-workspace-el-text">
                <div class="feedback-workspace-el-text-cursor" (click)="openEmail()">
                  {{ 'info@ilovefirstclass.com' }}
                </div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                <app-texts [texts]="[
            {text: ['Телефон', 'Phone']}
          ]"/>
              </div>
              <div class="feedback-workspace-el-text">
                <div class="feedback-workspace-el-text-cursor" (click)="openPhoneCall()">+66 99 160 97 11</div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                Telegram
              </div>
              <div class="feedback-workspace-el-text">
                <div class="feedback-workspace-el-text-cursor" (click)="openTelegram()">{{ '@ilovefirstclass' }}</div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                Whatsapp
              </div>
              <div class="feedback-workspace-el-text">
                <div class="feedback-workspace-el-text-cursor" (click)="openWhatsApp()">+66 99 160 97 11</div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                Instagram
              </div>
              <div class="feedback-workspace-el-text">
                <div class="feedback-workspace-el-text-cursor" (click)="openInstagramProfile()">{{ '@ilovefirstclass' }}</div>
              </div>
            </div>
          </div>
          <div class="feedback-workspace-right" *ngIf="showSection('right')">
            <div class="feedback-workspace-right-double-el">
              <div class="feedback-workspace-el">
                <div class="feedback-workspace-el-label">
                  <app-texts [texts]="[
              {text: ['Имя', 'Full name']}
            ]"/>
                </div>
                <input
                  id="fullName"
                  type="text"
                  inputmode="text"
                  formControlName="fullName"
                  [class.error]="isFieldInvalid('fullName')"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                >
                <div class="field-error" *ngIf="isFieldInvalid('fullName')">
                  <app-texts [texts]="[
              {text: ['Пожалуйста, введите ваше полное имя', 'Please enter your full name']}
            ]"/>
                </div>
              </div>
              <div class="feedback-workspace-el">
                <div class="feedback-workspace-el-label">
                  <app-texts [texts]="[
              {text: ['Компания', 'Company']}
            ]"/>
                </div>
                <input
                  id="company"
                  type="text"
                  inputmode="text"
                  formControlName="company"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                >
              </div>
            </div>
            <div class="feedback-workspace-right-double-el">
              <div class="feedback-workspace-el">
                <div class="feedback-workspace-el-label">
                  <app-texts [texts]="[
              {text: ['Телефон', 'phone number']}
            ]"/>
                </div>
                <input
                  id="phoneNumber"
                  type="text"
                  inputmode="text"
                  formControlName="phoneNumber"
                  [class.error]="isFieldInvalid('phoneNumber')"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                >
                <div class="field-error" *ngIf="isFieldInvalid('phoneNumber')">
                  <app-texts [texts]="[
              {text: ['Пожалуйста, введите корректный номер телефона', 'Please enter a valid phone number']}
            ]"/>
                </div>
              </div>
              <div class="feedback-workspace-el">
                <div class="feedback-workspace-el-label">
                  <app-texts [texts]="[
              {text: ['Почта', 'EMAIL']}
            ]"/>
                </div>
                <input
                  id="email"
                  type="text"
                  inputmode="text"
                  formControlName="email"
                  [class.error]="isFieldInvalid('email')"
                  (focus)="onInputFocus()"
                  (blur)="onInputBlur()"
                >
                <div class="field-error" *ngIf="isFieldInvalid('email')">
                  <app-texts [texts]="[
              {text: ['Пожалуйста, введите корректный адрес электронной почты', 'Please enter a valid email address']}
            ]"/>
                </div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                <app-texts [texts]="[
              {text: ['Тема запроса', 'Subject of the request']}
            ]"/>
              </div>
              <div class="feedback-dropdown">
                <div
                  class="dropdown-display"
                  [class.error]="isFieldInvalid('subject')"
                  (click)="openList = !openList"
                >
                  <ng-container *ngIf="currentSubjectText.text && (currentSubjectText.text[0] || currentSubjectText.text[1]); else noSelection">
                    <app-texts [texts]="[currentSubjectText]" />
                  </ng-container>
                  <ng-template #noSelection>
              <span>
                <app-texts [texts]="[
                  {text: ['Выберите тему', 'Select subject']}
                ]"/>
              </span>
                  </ng-template>
                </div>
                <input
                  id="subject"
                  type="hidden"
                  formControlName="subject"
                  [value]="value"
                  style="display: none"
                >
                <app-icon
                  [icon]="Icons.formArrow"
                  style="cursor: pointer"
                  (click)="openList = !openList"
                  [invert]="getInvert()"
                  [ngClass]="{ 'dropdown-arrow': true, 'open': openList }"
                />
                <div @slideInOut *ngIf="openList" class="feedback-dropdown-list">
                  <div *ngFor="let el of textsEl; index as i">
                    <div class="feedback-dropdown-list-el" (click)="selectItem(i)">
                      <app-texts [texts]="[el]" />
                    </div>
                  </div>
                </div>
                <div class="field-error" *ngIf="isFieldInvalid('subject')">
                  <app-texts [texts]="[
              {text: ['Пожалуйста, выберите тему', 'Please select a subject']}
            ]"/>
                </div>
              </div>
            </div>
            <div class="feedback-workspace-el">
              <div class="feedback-workspace-el-label">
                <app-texts [texts]="[
              {text: ['Сообщение', 'message']}
            ]"/>
              </div>
              <textarea
                id="message"
                type="text"
                inputmode="text"
                formControlName="message"
                #messageTextarea
                (input)="onInputMob(messageTextarea)"
                [class.error]="false"
                (focus)="onInputFocus()"
                (blur)="onInputBlur()"
              ></textarea>
            </div>
            <div class="item-button">
              <div class="button-content">
                <div
                  class="button-checkbox"
                  [ngClass]="{'warning': isCheckboxWarning}"
                  (click)="toggleRead()"
                >
                  <div class="button-checkbox-icon" *ngIf="read">
                    <app-icon [icon]="Icons.check" [invert]="!getInvert()"/>
                  </div>
                </div>
                <div class="button-checkbox-text" [ngClass]="{'warning': isCheckboxWarning}">
            <span class="checkbox-text-line">
              {{ text(['Даю согласие на обработку ', 'I have read the terms of ' ]) }}<span
              class="checkbox-link"
              [ngClass]="{'warning-link': isCheckboxWarning}"
              (click)="openPdf()"
              [innerText]="policyText"></span><span *ngIf="!isMobile">{{ text(['', ' and consent to the processing of personal data']) }}</span>
</span>
                </div>
              </div>
              <div class="submit-button-container">
                <div class="submit-button"
                     [class.disabled]="!read || isLoading"
                     [style.width]="isMobile ? '100%' : 'auto'"
                     [style.justify-content]="isMobile ? 'center' : ''"
                     [style.color]="isMobile ? 'white' : 'black'"
                     [style.background]="isMobile ? 'black' : 'white'"
                     (click)="postFeedback()">
            <span *ngIf="!isLoading">
              <app-texts [texts]="[
                {text: ['Отправить', 'Make request']}
              ]"/>
            </span>
                  <span *ngIf="isLoading" class="loading-text">
              <span class="loading-dot">.</span>
              <span class="loading-dot">.</span>
              <span class="loading-dot">.</span>
            </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
<!--    </div>-->
<!--  </div>-->
<!--  <div class="overlapping-content" [ngStyle]="getMarginStyles()">-->
<!--    <div class="feedback-mobile-contacts" [class.hidden]="menuService.getInputFocused()">-->
      <div class="feedback-mobile-contacts-content">
        <div class="feedback-mobile-contacts-content-label">
          contact us
        </div>
        <div class="feedback-mobile-contacts-content-el">Email</div>
        <div class="feedback-mobile-contacts-content-el black-el-margin" (click)="openEmail()">
          {{ 'info@ilovefirstclass.com' }}
        </div>
        <div class="feedback-mobile-contacts-content-el">Phone</div>
        <div class="feedback-mobile-contacts-content-el black-el-margin" (click)="openPhoneCall()">
          +66 99 160 97 11
        </div>
        <div class="feedback-mobile-contacts-content-el">Whatsapp</div>
        <div class="feedback-mobile-contacts-content-el black-el-margin" (click)="openWhatsApp()">
          +66 99 160 97 11
        </div>
        <div class="feedback-mobile-contacts-content-el">Telegram</div>
        <div class="feedback-mobile-contacts-content-el black-el-margin" (click)="openTelegram()">
          {{ '@ilovefirstclass' }}
        </div>
        <div class="feedback-mobile-contacts-content-el">INSTAGRAM</div>
        <div class="feedback-mobile-contacts-content-el" (click)="openInstagramProfile()">{{ '@ilovefirstclass' }}</div>
        <div class="feedback-mobile-contacts-content-el" style="margin-top: auto; margin-bottom: 5px">
          BR № 77889104<span>|</span>IATA TIDS 96223466
        </div>
        <div class="feedback-mobile-contacts-content-el">
          Cookie Policy |  Privacy Policy |   Public Offer
        </div>
        <div class="feedback-mobile-contacts-content-el">2026 © First Class Solutions Limited</div>
      </div>
<!--      <div class="feedback-mobile-contacts-fixed" *ngIf="!menuService.getInputFocused()"></div>-->
<!--    </div>-->
<!--  </div>-->
</div>
